@if (betslipResultState$ | async; as resultState) {
    @if (resultState.result.slips.length > 0) {
        @if (isLinear) {
            <bs-digital-linear-result [state]="resultState" [inColumn]="inColumn" [oddsDisplayFormat]="oddsDisplayFormat" />
        } @else {
            <bs-digital-result
                [state]="resultState"
                [trackingInformation]="betslipResultTrackingLocation"
                [inColumn]="inColumn"
                [oddsDisplayFormat]="oddsDisplayFormat" />
        }
    }
}
